// extracted by mini-css-extract-plugin
export default {"left":"K1oxnM4h_t","right-name":"Hlqvgumkxb","rightName":"Hlqvgumkxb","right":"L_kvYbLCFY","secret-inspector":"iWpsObDF5f","secretInspector":"iWpsObDF5f","description":"xtCwq0NiPT"};